<template>
  <div class="product-item" @click="goPage" :data-code="data.planCode" :data-name="data.planName" :data-index="data.listIndex">
    <div ref="prodImg" class="product-img-big" :style="{'height': imgHeight}">
      <img :src="(data.thumbnailUrl || data.headUrl) | imageToHttps | imageToWebp($webpSurpport)"/>
    </div>
    <div class="product-item-info">
      <!-- <div class="product-imgs">
        <img v-for="(item,index) in data.goodUrls" :key="index" :src="item | imageToHttps | imageToWebp($webpSurpport)"/>
      </div> -->
      <div class="product-title">{{data.planName}}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'productItem',
  props: ['data'],
  data() {
    return {
      imgWidth: ''
    }
  },
  computed: {
    imgHeight() {
      let imgHeight = (this.imgWidth * this.data.headHigh) / this.data.headWidth + 'px'
      return imgHeight
    }
  },
  mounted() {
    this.$util.setTimeOutFn(() => {
      this.imgWidth = this.$refs.prodImg && this.$refs.prodImg.offsetWidth
    })
  },
  methods: {
    goPage() {
      this.$emit('handleClick')
    }
  }
}
</script>

<style lang="scss" scoped>
.product-img-big{
  img{
    width: 100%;
    height: 100%;
  }
}
.product-item-info{
  padding: .16rem .2rem;
}
.product-imgs{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  img{
    margin-right: .1rem;
    width: .92rem;
    height: .92rem;
    border-radius: 2px;
    &:last-child{
      margin-right: 0;
    }
  }
}
.product-title{
  /* padding-top: .24rem; */
  padding: .2rem 0;
  font-size: .26rem;
  color: #333;
  font-weight: 500;
}
</style>
